import { useState, useEffect } from "react";
import { useAuthContext } from "./useAuthContext";
import { projectFirestore, timestamp } from "../../firebase-config/config";
import { useFirestore } from "./useFirestore";
import {
  generateBarcodeNumber,
  generateBarcodeDataURL,
} from "../../utility/barcodeGenerator";
import { generateItemBarcodeDataURL } from "../../utility/itemBarcodeGenerator";
import { useSendEmail } from "./useSendEmail";
import { useDocument } from "./useDocument";

const useOrders = () => {
  const { sendMyEmail } = useSendEmail();
  const [orders, setOrders] = useState([]);
  const { user } = useAuthContext();
  const { addDocument, updateDocument } = useFirestore("orders");
  const { document: dbEmailDoc } = useDocument(
    "email_templates",
    "place_order_temp"
  );
  const { document: siteColors } = useDocument("settings", "Colors");
  const { document: organisationDoc } = useDocument("settings", "organisation");
  useEffect(() => {
    if (user) {
      const unsubscribe = projectFirestore
        .collection("orders")
        .where("orderAssignedTo", "==", user.phoneNumber)
        .onSnapshot((snapshot) => {
          const items = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setOrders(items);
        });

      return () => {
        unsubscribe();
        // unsubscribeAssigned();
      };
    }
  }, [user]);

  // const createOrder = async (
  //   orderProducts,
  //   orderPrice,
  //   address = null,
  //   paymentMethod,
  //   instruction = null,
  //   giftMessages = null,
  //   paymentDetails = null,
  //   isQuickPickup = false,
  //   expectedClothsQuantity = null
  // ) => {
  //   const orderData = {
  //     products: isQuickPickup ? [] : orderProducts,
  //     totalPrice: isQuickPickup ? 0 : orderPrice,
  //     shippingAddress: address || null,
  //     paymentMethod: paymentMethod,
  //     instruction: instruction || null,
  //     giftMessages: giftMessages || "",
  //     orderStatus: paymentMethod === "online" ? "payment_pending" : "pending",
  //     currentOrderStage: "orderPlaced",
  //     orderType: isQuickPickup ? "quick_pickup" : "normal",
  //     estimatedDeliveryDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
  //     expectedClothsQuantity: expectedClothsQuantity
  //       ? expectedClothsQuantity
  //       : null,
  //     orderStages: {
  //       orderPlaced: {
  //         completed: true,
  //         timestamp: timestamp.fromDate(new Date()),
  //       },
  //       itemsPickedUp: {
  //         completed: false,
  //         timestamp: null,
  //       },
  //       processing: {
  //         completed: false,
  //         timestamp: null,
  //       },
  //       delivered: {
  //         completed: false,
  //         timestamp: null,
  //       },
  //     },

  //     // Add location fields
  //     selectedLocation: user?.selectedLocation || null,

  //     // Payment related fields
  //     payment: {
  //       method: paymentMethod,
  //       status: paymentDetails?.paymentStatus || "pending",
  //       transactionId: paymentDetails?.transactionID || "",
  //       amount: orderPrice,
  //       currency: "INR",
  //       timestamp:
  //         paymentDetails?.paymentDetails?.timestamp ||
  //         timestamp.fromDate(new Date()),
  //       details: paymentDetails?.paymentDetails || null,
  //       refund: {
  //         status: "none",
  //         amount: 0,
  //         timestamp: null,
  //         transactionId: "",
  //       },
  //     },

  //     orderAssignedTo: user.phoneNumber,
  //     orderAssignedOn: timestamp.fromDate(new Date()),
  //     // Add staff assignment fields
  //     pickupStaff: null,
  //     processingStaff: null,
  //     deliveryStaff: null,

  //     //START PAYMENT RELATED FIELDS
  //     transactionid: "",
  //     transactionstatus: "",
  //     transactiontimestamp: "",
  //     transactionamount: "",
  //     isrefunded: "",
  //     refundedamount: "",
  //     refundedtimestamp: "",
  //     refundstatus: "",
  //     //END PAYMENT RELATED FIELDS

  //     createdAt: timestamp.fromDate(new Date()),
  //     userId: user.phoneNumber,
  //     adminCreatedOrder: user.role === "admin",
  //     // Initialize timeline array for all orders, not just admin-created ones
  //     timeline: [
  //       {
  //         id: `ORDER_CREATED_${Date.now()}`,
  //         eventType: isQuickPickup ? "QUICK_PICKUP_CREATED" : "ORDER_CREATED",
  //         details: {
  //           createdByAdmin: user.role === "admin",
  //           orderTotal: isQuickPickup ? 0 : orderPrice,
  //           productCount: isQuickPickup ? 0 : orderProducts.length,
  //           isQuickPickup: isQuickPickup,
  //           expectedClothsQuantity: expectedClothsQuantity,
  //         },
  //         timestamp: timestamp.fromDate(new Date()),
  //         createdBy: {
  //           userId: user.phoneNumber,
  //           userName: user.fullName || user.email || "System",
  //           role: user.role,
  //         },
  //       },
  //     ],
  //   };

  //   console.log("Normal Order created");

  //   try {
  //     const addedDocRef = await addDocument(orderData);
  //     const orderId = addedDocRef.id;

  //     // Generate QR code
  //     const qrCodeImage = await generateBarcodeDataURL(orderId);

  //     // Generate QR codes for each item in the order
  //     const productsWithQR = await Promise.all(
  //       orderProducts.map(async (product, index) => {
  //         const itemId = `${orderId}-item-${index}`;
  //         const itemQRCode = await generateItemBarcodeDataURL(orderId, itemId, {
  //           productId: product.id,
  //           name: product.name,
  //           quantity: product.quantity,
  //         });

  //         return {
  //           ...product,
  //           itemId,
  //           itemQRCode,
  //         };
  //       })
  //     );

  //     // Update the document with the QR codes
  //     const updates = {
  //       barcode: {
  //         number: orderId,
  //         imageUrl: qrCodeImage,
  //       },
  //       products: productsWithQR, // Update products array with QR codes
  //     };

  //     if (paymentDetails) {
  //       const paymentEvent = {
  //         id: `PAYMENT_${Date.now()}`,
  //         eventType: "PAYMENT",
  //         details: {
  //           status: paymentDetails.paymentStatus,
  //           transactionId: paymentDetails.transactionID,
  //           amount: orderPrice,
  //           method: paymentMethod,
  //         },
  //         timestamp: timestamp.fromDate(new Date()),
  //         createdBy: {
  //           userId: user.phoneNumber,
  //           userName: user.fullName || user.email || "System",
  //           role: user.role,
  //         },
  //       };
  //       updates.timeline = [...(orderData.timeline || []), paymentEvent];
  //     }

  //     await addedDocRef.update(updates);

  //     const addedDocSnap = await addedDocRef.get();

  //     // ✅ Handle "Subscribe & Save" — create multiple future orders
  //     const firstProduct = orderProducts[0];
  //     if (
  //       firstProduct?.selectedFrequencyType &&
  //       firstProduct?.deliveryInterval
  //     ) {
  //       const isWeekly = firstProduct.selectedFrequencyType === "weekly";
  //       const totalOrders = parseInt(
  //         firstProduct.deliveryInterval.match(/\d+/)?.[0] || "0",
  //         10
  //       );
  //       const selectedDay = firstProduct.selectedDay;
  //       const selectedDate = firstProduct.selectedDate;

  //       const getNextWeekdayDate = (dayName, weekOffset = 0) => {
  //         const daysOfWeek = [
  //           "Sunday",
  //           "Monday",
  //           "Tuesday",
  //           "Wednesday",
  //           "Thursday",
  //           "Friday",
  //           "Saturday",
  //         ];
  //         const targetDay = daysOfWeek.indexOf(dayName);
  //         const now = new Date();
  //         const date = new Date(now);
  //         const diff = (targetDay - now.getDay() + 7) % 7;
  //         date.setDate(now.getDate() + diff + weekOffset * 7);
  //         return date;
  //       };

  //       const getNextMonthDate = (baseDateStr, monthOffset = 1) => {
  //         const base = new Date(baseDateStr);
  //         const next = new Date(base);
  //         const day = base.getDate();
  //         next.setMonth(base.getMonth() + monthOffset);
  //         if (next.getDate() !== day) next.setDate(0);
  //         return next;
  //       };

  //       let baseDeliveryDate;
  //       if (isWeekly && selectedDay) {
  //         baseDeliveryDate = getNextWeekdayDate(selectedDay, 0);
  //       } else if (!isWeekly && selectedDate) {
  //         baseDeliveryDate = new Date(selectedDate);
  //       } else {
  //         baseDeliveryDate = new Date(); // fallback: today
  //       }

  //       // ✅ Create (totalOrders - 1) repeat orders
  //       for (let i = 1; i < totalOrders; i++) {
  //         let nextDeliveryDate;
  //         if (isWeekly && selectedDay) {
  //           nextDeliveryDate = getNextWeekdayDate(selectedDay, i);
  //         } else if (!isWeekly && selectedDate) {
  //           nextDeliveryDate = getNextMonthDate(selectedDate, i);
  //         } else {
  //           nextDeliveryDate = new Date(baseDeliveryDate);
  //           nextDeliveryDate.setDate(
  //             nextDeliveryDate.getDate() + i * (isWeekly ? 7 : 30)
  //           );
  //         }

  //         const repeatOrder = {
  //           ...orderData,
  //           estimatedDeliveryDate: nextDeliveryDate,
  //           subscriptionParentOrder: addedDocSnap.id,
  //           subscriptionIndex: i,
  //           createdAt: timestamp.fromDate(new Date()),
  //           timeline: [
  //             {
  //               id: `SUBSCRIPTION_ORDER_${Date.now()}_${i}`,
  //               eventType: "SUBSCRIPTION_ORDER_CREATED",
  //               details: {
  //                 frequencyType: firstProduct.selectedFrequencyType,
  //                 deliveryInterval: firstProduct.deliveryInterval,
  //                 selectedDay: selectedDay || null,
  //                 selectedDate: selectedDate || null,
  //                 createdFromParent: addedDocSnap.id,
  //               },
  //               timestamp: timestamp.fromDate(new Date()),
  //               createdBy: {
  //                 userId: user.phoneNumber,
  //                 userName: user.fullName || user.email || "System",
  //                 role: user.role,
  //               },
  //             },
  //           ],
  //         };

  //         await addDocument(repeatOrder);
  //       }
  //     }

  //     return { id: addedDocSnap.id, ...addedDocSnap.data() };
  //   } catch (error) {
  //     console.error("Error creating order:", error);
  //     return null;
  //   }
  // };
  const createOrder = async (
    orderProducts,
    orderPrice,
    address = null,
    paymentMethod,
    instruction = null,
    giftMessages = null,
    paymentDetails = null,
    isQuickPickup = false,
    expectedClothsQuantity = null
  ) => {
    // --- 1. Subscription Logic ---
    const firstProduct = orderProducts[0];
    let subscriptionBaseDate = null;
    let totalOrders = 1;
    let isSubscription = false;
    let subscriptionDetails = {};

    if (
      !isQuickPickup &&
      firstProduct?.selectedFrequencyType &&
      firstProduct?.deliveryInterval
    ) {
      isSubscription = true;
      totalOrders = parseInt(
        firstProduct.deliveryInterval.match(/\d+/)?.[0] || "0",
        10
      );
      subscriptionDetails = {
        isWeekly: firstProduct.selectedFrequencyType === "week",
        selectedDay: firstProduct.selectedDeliveryDay, // e.g., "Tuesday"
        selectedDate: firstProduct.selectedDeliveryDate, // Could be "10" or "2025-11-10"
      };
    }

    // --- 2. Calculate the FIRST delivery date (baseDeliveryDate) ---
    if (isSubscription) {
      console.log("Subscription Details:", subscriptionDetails);
      console.log("First Product:", firstProduct);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Normalize time
      let baseDate = new Date(today.getTime());

      if (subscriptionDetails.isWeekly) {
        // Weekly Logic
        const daysOfWeek = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];

        // Validate selectedDay exists
        if (!subscriptionDetails.selectedDay) {
          console.error("Weekly subscription requires selectedDay");
          // Fallback to next Monday
          baseDate.setDate(
            today.getDate() + ((1 - today.getDay() + 7) % 7 || 7)
          );
        } else {
          const targetDay = daysOfWeek.indexOf(subscriptionDetails.selectedDay);

          // Check if selectedDay is valid
          if (targetDay === -1) {
            console.error(
              "Invalid selectedDay:",
              subscriptionDetails.selectedDay
            );
            // Fallback to next Monday
            baseDate.setDate(
              today.getDate() + ((1 - today.getDay() + 7) % 7 || 7)
            );
          } else {
            const currentDay = today.getDay();

            // Calculate days to add to get to the next occurrence of target day
            let daysToAdd = (targetDay - currentDay + 7) % 7;

            // If the target day is today (daysToAdd === 0), we want today, not next week
            if (daysToAdd === 0) {
              daysToAdd = 0; // Use today if it's the selected day
            }

            baseDate.setDate(today.getDate() + daysToAdd);
          }
        }
      } else {
        // Monthly Logic - FIX: Extract day number properly
        let targetDate;

        // Check if selectedDate exists and is valid
        if (!subscriptionDetails.selectedDate) {
          console.error("Monthly subscription requires selectedDate");
          targetDate = 1; // Fallback to 1st of month
        } else if (subscriptionDetails.selectedDate.seconds) {
          // It's a Firestore Timestamp object like {seconds: 1762819200, nanoseconds: 0}
          const dateObj = new Date(
            subscriptionDetails.selectedDate.seconds * 1000
          );
          targetDate = dateObj.getDate();
        } else if (subscriptionDetails.selectedDate.toDate) {
          // It's a Firestore Timestamp with toDate() method
          const dateObj = subscriptionDetails.selectedDate.toDate();
          targetDate = dateObj.getDate();
        } else if (
          typeof subscriptionDetails.selectedDate === "string" &&
          subscriptionDetails.selectedDate.includes("-")
        ) {
          // It's a date string like "2025-11-10"
          const dateObj = new Date(subscriptionDetails.selectedDate);
          targetDate = dateObj.getDate();
        } else {
          // It's just a day number like "10" or 10
          targetDate = parseInt(subscriptionDetails.selectedDate, 10);
        }

        // Validate targetDate is between 1-31
        if (isNaN(targetDate) || targetDate < 1 || targetDate > 31) {
          console.error("Invalid target date:", targetDate);
          targetDate = 1; // Fallback to 1st of month
        }

        // Set to target day of current month
        baseDate.setDate(targetDate);

        // If that date has already passed this month, move to next month
        if (baseDate < today) {
          baseDate.setMonth(baseDate.getMonth() + 1);
          baseDate.setDate(targetDate); // Reset to target date after month change
        }
      }
      subscriptionBaseDate = baseDate;
    }

    // --- Helper function for monthly date calculation ---
    const getNextMonthDate = (baseDate, monthOffset) => {
      const next = new Date(baseDate.getTime()); // Clone the base date
      const originalDay = baseDate.getDate(); // e.g., 31

      next.setMonth(baseDate.getMonth() + monthOffset);

      // Handle end-of-month overflow (e.g., Jan 31 -> Feb 31 becomes Mar 3)
      // If the day changed, it means we overflowed, so set to last day of intended month
      if (next.getDate() !== originalDay) {
        // Set to day 0 of next month = last day of current month
        next.setDate(0);
      }
      return next;
    };

    // --- 3. Build the Parent Order Data Object ---
    const orderData = {
      products: isQuickPickup ? [] : orderProducts,
      totalPrice: isQuickPickup ? 0 : orderPrice,
      shippingAddress: address || null,
      paymentMethod: paymentMethod,
      instruction: instruction || null,
      giftMessages: giftMessages || "",
      orderStatus: paymentMethod === "online" ? "payment_pending" : "pending",
      currentOrderStage: "orderPlaced",
      orderType: isQuickPickup ? "quick_pickup" : "normal",

      // Use subscription date if available, else use fallback
      estimatedDeliveryDate:
        subscriptionBaseDate ||
        (isQuickPickup ? null : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)),

      expectedClothsQuantity: expectedClothsQuantity || null,
      orderStages: {
        orderPlaced: {
          completed: true,
          timestamp: timestamp.fromDate(new Date()),
        },
        itemsPickedUp: { completed: false, timestamp: null },
        processing: { completed: false, timestamp: null },
        delivered: { completed: false, timestamp: null },
      },
      selectedLocation: user?.selectedLocation || null,

      payment: {
        method: paymentMethod,
        status: paymentDetails?.paymentStatus || "pending",
        transactionId: paymentDetails?.transactionID || "",
        amount: orderPrice,
        currency: "INR",
        timestamp:
          paymentDetails?.paymentDetails?.timestamp ||
          timestamp.fromDate(new Date()),
        details: paymentDetails?.paymentDetails || null,
        refund: {
          status: "none",
          amount: 0,
          timestamp: null,
          transactionId: "",
        },
      },

      orderAssignedTo: user.phoneNumber,
      orderAssignedOn: timestamp.fromDate(new Date()),
      pickupStaff: null,
      processingStaff: null,
      deliveryStaff: null,
      createdAt: timestamp.fromDate(new Date()),
      userId: user.phoneNumber,
      adminCreatedOrder: user.role === "admin",
      timeline: [
        {
          id: `ORDER_CREATED_${Date.now()}`,
          eventType: isQuickPickup ? "QUICK_PICKUP_CREATED" : "ORDER_CREATED",
          details: {
            createdByAdmin: user.role === "admin",
            orderTotal: isQuickPickup ? 0 : orderPrice,
            productCount: isQuickPickup ? 0 : orderProducts.length,
            isQuickPickup: isQuickPickup,
            expectedClothsQuantity: expectedClothsQuantity,
          },
          timestamp: timestamp.fromDate(new Date()),
          createdBy: {
            userId: user.phoneNumber,
            userName: user.fullName || user.email || "System",
            role: user.role,
          },
        },
      ],
    };

    console.log("Creating order...");

    try {
      // --- 4. Add the Parent Order to Firestore ---
      const addedDocRef = await addDocument(orderData);
      const orderId = addedDocRef.id;

      // --- 5. Generate Barcodes for Parent Order ---
      const qrCodeImage = await generateBarcodeDataURL(orderId);
      const productsWithQR = await Promise.all(
        orderProducts.map(async (product, index) => {
          const itemId = `${orderId}-item-${index}`;
          const itemQRCode = await generateItemBarcodeDataURL(orderId, itemId, {
            productId: product.id,
            name: product.name,
            quantity: product.quantity,
          });
          return { ...product, itemId, itemQRCode };
        })
      );

      // --- 6. Update Parent Order with Barcodes ---
      const updates = {
        barcode: {
          number: orderId,
          imageUrl: qrCodeImage,
        },
        products: productsWithQR,
      };

      if (paymentDetails) {
        const paymentEvent = {
          id: `PAYMENT_${Date.now()}`,
          eventType: "PAYMENT",
          details: {
            status: paymentDetails.paymentStatus,
            transactionId: paymentDetails.transactionID,
            amount: orderPrice,
            method: paymentMethod,
          },
          timestamp: timestamp.fromDate(new Date()),
          createdBy: {
            userId: user.phoneNumber,
            userName: user.fullName || user.email || "System",
            role: user.role,
          },
        };
        updates.timeline = [...(orderData.timeline || []), paymentEvent];
      }

      await addedDocRef.update(updates);
      const addedDocSnap = await addedDocRef.get();

      // --- 6.5. Create orderItems documents for each product ---

      if (!isQuickPickup && productsWithQR.length > 0) {

        const orderItemsBatch = projectFirestore.batch();

        

        productsWithQR.forEach((product) => {

          const orderItemRef = projectFirestore

            .collection("orderItems")

            .doc(product.itemId);

          

          const orderItemData = {

            itemId: product.itemId,

            orderId: orderId,

            productId: product.id,

            productName: product.name,

            quantity: product.quantity,

            currentStage: "order_placed",

            currentSubStage: null,

            status: "in_progress",

            issues: [],

            history: [],

            createdAt: timestamp.fromDate(new Date()),

            updatedAt: timestamp.fromDate(new Date()),

          };

          

          orderItemsBatch.set(orderItemRef, orderItemData);

        });

        

        await orderItemsBatch.commit();

        console.log(`Created ${productsWithQR.length} orderItems documents.`);

      }

      // --- 7. Handle Subscription: Create Child Orders in a BATCH ---
      if (isSubscription && totalOrders > 1) {
        console.log(`Creating ${totalOrders - 1} subscription child orders...`);

        const batch = projectFirestore.batch();

        // Create (totalOrders - 1) repeat orders
        for (let i = 1; i < totalOrders; i++) {
          let nextDeliveryDate;

          if (subscriptionDetails.isWeekly) {
            // Add i weeks to base date
            nextDeliveryDate = new Date(subscriptionBaseDate.getTime());
            nextDeliveryDate.setDate(subscriptionBaseDate.getDate() + i * 7);
          } else {
            // Add i months to base date, handling month-end properly
            nextDeliveryDate = getNextMonthDate(subscriptionBaseDate, i);
          }

          const newOrderRef = projectFirestore.collection("orders").doc();

          const repeatOrder = {
            ...orderData,
            estimatedDeliveryDate: nextDeliveryDate,
            subscriptionParentOrder: addedDocSnap.id,
            subscriptionIndex: i,
            createdAt: timestamp.fromDate(new Date()),

            // Reset order status and stages
            orderStatus:
              orderData.paymentMethod === "online"
                ? "payment_pending"
                : "pending",
            currentOrderStage: "orderPlaced",
            orderStages: {
              orderPlaced: {
                completed: true,
                timestamp: timestamp.fromDate(new Date()),
              },
              itemsPickedUp: { completed: false, timestamp: null },
              processing: { completed: false, timestamp: null },
              delivered: { completed: false, timestamp: null },
            },

            // Reset payment status
            payment: {
              ...orderData.payment,
              status: "pending",
              transactionId: "",
              details: null,
            },

            timeline: [
              {
                id: `SUBSCRIPTION_ORDER_${Date.now()}_${i}`,
                eventType: "SUBSCRIPTION_ORDER_CREATED",
                details: {
                  frequencyType: firstProduct.selectedFrequencyType,
                  deliveryInterval: firstProduct.deliveryInterval,
                  selectedDay: subscriptionDetails.selectedDay || null,
                  selectedDate: subscriptionDetails.selectedDate || null,
                  createdFromParent: addedDocSnap.id,
                  scheduledFor: nextDeliveryDate.toISOString(),
                },
                timestamp: timestamp.fromDate(new Date()),
                createdBy: {
                  userId: user.phoneNumber,
                  userName: user.fullName || user.email || "System",
                  role: user.role,
                },
              },
            ],
          };

          batch.set(newOrderRef, repeatOrder);
        }

        await batch.commit();
        console.log("Batch commit successful for child orders.");
      }

      // START FOR SEND EMAIL (Order Confirmation UI)
      if (dbEmailDoc && dbEmailDoc.status === true) {
        const order = addedDocSnap.data();

        // make sure you have order data available here
        const placedOrderId = orderId || "Order Id";

        const orderDate = order?.createdAt
          ? new Date(order.createdAt.seconds * 1000).toLocaleString()
          : new Date().toLocaleString();

        // orderItems should be an array of { name, qty, price, variant(optional) }
        const orderItems = order?.products;

        const total = order?.totalPrice;
        const paymentMethod = order?.paymentMethod || "Online";
        let deliveryAddress = `${user?.fullName || ""}, ${
          user?.phoneNumber || ""
        }`;
        if (order?.shippingAddress) {
          const a = order.shippingAddress;
          deliveryAddress = `
    ${a.name || ""}<br>
    ${a.houseNumber || ""}, ${a.streetLineOne || ""}<br>
    ${a.streetLineTwo ? a.streetLineTwo + "<br>" : ""}
    ${a.landmark ? a.landmark + "<br>" : ""}
    ${a.city || ""}, ${a.state || ""} - ${a.pincode || ""}<br>
    <span style="font-size:12px; color:#666;">(${a.type || "home"})</span>`;
        }

        let expectedDelivery = "Typically 7–10 business days";

        if (order?.estimatedDeliveryDate) {
          try {
            const d =
              order.estimatedDeliveryDate.toDate?.() ||
              new Date(order.estimatedDeliveryDate.seconds * 1000);

            expectedDelivery = d.toLocaleDateString("en-IN", {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
            });
          } catch (e) {
            console.log("Delivery date parse error:", e);
          }
        }

        // Build items rows HTML safely
        const itemsRows = orderItems.length
          ? orderItems
              .map(
                (it) => `
      <tr style="background:#fff;">
     <td style="padding:10px 12px; border-bottom:1px solid #eee;">
  <div style="display:flex; align-items:center; gap:10px;">
    
    ${
      it.images && it.images.length > 0
        ? `<img 
           src="${it.images[0]}" 
           alt="Item"
           width="50" 
           height="50" 
           style="border-radius:6px; object-fit:cover;"
         />`
        : ""
    }

    <div>
      <div style="font-weight:600; color:#333;">${it.name || ""}</div>
      ${
        it.variant
          ? `<div style="font-size:12px; color:#777;">${it.variant}</div>`
          : ""
      }
    </div>
  </div>
</td>
  
        <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:center; color:#333;">${
          it.quantity
        }</td>
        <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:right; color:#333;">
  <div style="font-size:12px; color:#777;">
₹${it.price} * ${it.quantity}
  </div>
   ₹${(it.price * it.quantity).toFixed(2)}
</td>

      </tr>
    `
              )
              .join("")
          : `<tr><td colspan="3" style="padding:18px; text-align:center; color:#777;">No items found</td></tr>`;

        const toList = [user && user.email];
        const ccList = dbEmailDoc?.ccList || [];
        const bccList = dbEmailDoc?.bccList || [];
        const emailSubject =
          dbEmailDoc?.subject || `Order Confirmation - ${order}`;

        const htmlEmailBody = `
  <div style="font-family: Arial, sans-serif; background-color:#f4f6f9; padding:20px;">
    <table width="100%" border="0" cellspacing="0" cellpadding="0"
      style="max-width:700px; margin:0 auto; background:#ffffff; border-radius:12px; overflow:hidden; box-shadow:0 6px 18px rgba(0,0,0,0.06);">
      
      <!-- Header -->
      <tr>
        <td style="background: ${
          siteColors?.LightScreenTheme?.clickColor || "#0b4c8c"
        }; padding:26px 20px; text-align:left; color:#fff;">
          <table width="100%"><tr>
            <td style="vertical-align:middle;">
              <img src="${
                organisationDoc?.logoUrl || ""
              }" alt="Logo" width="120" style="vertical-align:middle; border-radius:6px;" />
            </td>
            <td style="text-align:right; vertical-align:middle;">
              <div style="font-size:18px; font-weight:600;">Order Confirmed</div>
              <div style="font-size:13px; opacity:0.9; margin-top:6px;">Order # <strong>${placedOrderId}</strong></div>
              <div style="font-size:12px; opacity:0.85; margin-top:4px;">${orderDate}</div>
            </td>
          </tr></table>
        </td>
      </tr>

      <!-- Greeting / Intro -->
      <tr>
        <td style="padding:22px 28px;">
          <h2 style="margin:0 0 6px 0; font-size:20px; color:#222;">Thanks for your order, ${
            user?.fullName || "Customer"
          } 👋</h2>
          <p style="margin:6px 0 0 0; font-size:14px; color:#555;">
            We’ve received your order and are getting it ready. Below are the details for your reference.
          </p>
        </td>
      </tr>

  

<!-- Customer & Delivery Details (STACKED) -->
<tr>
  <td style="padding:0 28px 22px 28px;">
    
    <!-- Customer -->
    <div style="font-weight:700; color:#333; margin-bottom:8px;">Customer Details</div>
    <div style="color:#444;">${user?.fullName || ""}</div>
    <div style="color:#444;">${user?.email || ""}</div>
    <div style="color:#444; margin-bottom:16px;">${
      user?.phoneNumber || ""
    }</div>

    <!-- Delivery -->
    <div style="font-weight:700; color:#333; margin-bottom:8px;">Delivery Details</div>
    <div style="color:#444;">${deliveryAddress}</div>

    <div style="margin-top:8px; color:#666; font-size:13px;">
      Expected delivery: <strong>${expectedDelivery}</strong>
    </div>
  </td>
</tr>



      <!-- Items Table -->
      <tr>
        <td style="padding:0 28px 8px 28px;">
          <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse; font-size:14px;">
            <thead>
              <tr style="background:#f7fafc;">
                <th style="text-align:left; padding:12px; color:#666; font-weight:600;">Item</th>
                <th style="text-align:center; padding:12px; color:#666; font-weight:600;">Qty</th>
                <th style="text-align:right; padding:12px; color:#666; font-weight:600;">Price</th>
              </tr>
            </thead>
            <tbody>
              ${itemsRows}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- Totals -->
     <!-- Payment Method -->
    <tr>
  <td style="padding:10px 28px 22px 28px;">

    <!-- PAYMENT ROW (RIGHT SIDE, ABOVE TOTAL) -->
    <div style="text-align:right; font-size:15px; font-weight:600; color:#444; margin-bottom:6px;">
      Payment: <strong>${paymentMethod}</strong>
    </div>

    <!-- TOTAL ROW -->
    <table width="100%" cellpadding="6" cellspacing="0"
      style="border-collapse:collapse; font-size:14px;">

      <tr style="border-top:1px solid #eee;">

        <!-- LEFT SIDE: Total -->
        <td style="vertical-align:top; text-align:left;">
          <div style="font-size:20px; font-weight:600; color:#444;">
            Total
          </div>
        </td>

        <!-- RIGHT SIDE: Amount -->
        <td style="vertical-align:top; text-align:right;">
          <div style="font-size:20px; font-weight:700; color:#000;">
            ₹${total}
          </div>
        </td>
      </tr>
    </table>
  </td>
</tr>

      <!-- CTA Buttons -->
      <tr>
        <td style="padding:0 28px 26px 28px; text-align:center;">
         <a href="${
           organisationDoc?.siteUrl
             ? `${organisationDoc.siteUrl}/order-details/${placedOrderId}`
             : "#"
         }" 
  target="_blank"
  style="display:inline-block; background:${
    siteColors?.LightScreenTheme?.clickColor || "#0b4c8c"
  }; color:#fff; padding:12px 20px; border-radius:8px; text-decoration:none; font-weight:600; margin-right:10px;">
  View Order
</a>

            <a href="${
              organisationDoc?.siteUrl
                ? `${organisationDoc.siteUrl}/orders`
                : "#"
            }" 
  target="_blank"
  style="display:inline-block; background:#f1f5f9; color:#333; padding:12px 18px; border-radius:8px; text-decoration:none; font-weight:600; border:1px solid #e2e8f0;">
  Track Order
</a>
        </td>
      </tr>

      <!-- Footer -->
      <tr>
        <td style="background:#fafafa; padding:18px 20px; text-align:center; font-size:12px; color:#888;">
          If you have any questions, reply to this email or contact our support.<br/>
          &copy; ${new Date().getFullYear()} ${
          organisationDoc?.full_name || ""
        }. All rights reserved.
        </td>
      </tr>
    </table>
  </div>
  `;

        // send (keeps your current signature - you can change to sendMyEmail(toList, htmlEmailBody) if hook changed)
        await sendMyEmail(toList, ccList, bccList, emailSubject, htmlEmailBody);
      }
      //  END FOR SEND EMAIL

      return { id: addedDocSnap.id, ...addedDocSnap.data() };
    } catch (error) {
      console.error("Error creating order:", error);
      return null;
    }
  };

  const createAdminOrder = async (
    orderProducts,
    orderPrice,
    address = null,
    paymentMethod,
    instruction = null,
    giftMessages,
    orderAssignedTo,
    paymentDetails = null,
    isQuickPickup = false,
    expectedClothsQuantity = null
  ) => {
    // --- 1. Subscription Logic ---
    const firstProduct = orderProducts[0];
    let subscriptionBaseDate = null;
    let totalOrders = 1;
    let isSubscription = false;
    let subscriptionDetails = {};

    if (
      !isQuickPickup &&
      firstProduct?.selectedFrequencyType &&
      firstProduct?.deliveryInterval
    ) {
      isSubscription = true;
      totalOrders = parseInt(
        firstProduct.deliveryInterval.match(/\d+/)?.[0] || "0",
        10
      );
      subscriptionDetails = {
        isWeekly: firstProduct.selectedFrequencyType === "week",
        selectedDay: firstProduct.selectedDeliveryDay,
        selectedDate: firstProduct.selectedDeliveryDate,
      };
    }

    // --- 2. Calculate Base Delivery Date ---
    if (isSubscription) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let baseDate = new Date(today.getTime());

      if (subscriptionDetails.isWeekly) {
        // Weekly Logic
        const daysOfWeek = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];

        if (!subscriptionDetails.selectedDay) {
          baseDate.setDate(
            today.getDate() + ((1 - today.getDay() + 7) % 7 || 7)
          );
        } else {
          const targetDay = daysOfWeek.indexOf(subscriptionDetails.selectedDay);
          const currentDay = today.getDay();
          let daysToAdd = (targetDay - currentDay + 7) % 7;
          if (daysToAdd === 0) daysToAdd = 0;
          baseDate.setDate(today.getDate() + daysToAdd);
        }
      } else {
        // Monthly Logic
        let targetDate;

        if (!subscriptionDetails.selectedDate) {
          targetDate = 1;
        } else if (subscriptionDetails.selectedDate.seconds) {
          const dateObj = new Date(
            subscriptionDetails.selectedDate.seconds * 1000
          );
          targetDate = dateObj.getDate();
        } else if (subscriptionDetails.selectedDate.toDate) {
          const dateObj = subscriptionDetails.selectedDate.toDate();
          targetDate = dateObj.getDate();
        } else if (
          typeof subscriptionDetails.selectedDate === "string" &&
          subscriptionDetails.selectedDate.includes("-")
        ) {
          const dateObj = new Date(subscriptionDetails.selectedDate);
          targetDate = dateObj.getDate();
        } else {
          targetDate = parseInt(subscriptionDetails.selectedDate, 10);
        }

        if (isNaN(targetDate) || targetDate < 1 || targetDate > 31) {
          targetDate = 1;
        }

        baseDate.setDate(targetDate);
        if (baseDate < today) {
          baseDate.setMonth(baseDate.getMonth() + 1);
          baseDate.setDate(targetDate);
        }
      }

      subscriptionBaseDate = baseDate;
    }

    // --- Helper function for monthly date calculation ---
    const getNextMonthDate = (baseDate, monthOffset) => {
      const next = new Date(baseDate.getTime());
      const originalDay = baseDate.getDate();
      next.setMonth(baseDate.getMonth() + monthOffset);
      if (next.getDate() !== originalDay) next.setDate(0);
      return next;
    };

    // --- 3. Build Order Data ---
    const orderData = {
      products: isQuickPickup ? [] : orderProducts,
      totalPrice: isQuickPickup ? 0 : orderPrice,
      shippingAddress: address || null,
      paymentMethod,
      instruction: instruction || null,
      giftMessages: giftMessages || "",
      orderStatus: paymentMethod === "online" ? "payment_pending" : "pending",
      currentOrderStage: "orderPlaced",
      orderType: isQuickPickup ? "quick_pickup" : "normal",
      estimatedDeliveryDate:
        subscriptionBaseDate ||
        (isQuickPickup ? null : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)),
      expectedClothsQuantity: expectedClothsQuantity || null,
      orderStages: {
        orderPlaced: {
          completed: true,
          timestamp: timestamp.fromDate(new Date()),
        },
        itemsPickedUp: { completed: false, timestamp: null },
        processing: { completed: false, timestamp: null },
        delivered: { completed: false, timestamp: null },
      },
      selectedLocation: user?.selectedLocation || null,
      payment: {
        method: paymentMethod,
        status: paymentDetails?.paymentStatus || "pending",
        transactionId: paymentDetails?.transactionID || "",
        amount: orderPrice,
        currency: "INR",
        timestamp:
          paymentDetails?.paymentDetails?.timestamp ||
          timestamp.fromDate(new Date()),
        details: paymentDetails?.paymentDetails || null,
        refund: {
          status: "none",
          amount: 0,
          timestamp: null,
          transactionId: "",
        },
      },
      orderAssignedTo,
      orderAssignedOn: timestamp.fromDate(new Date()),
      pickupStaff: null,
      processingStaff: null,
      deliveryStaff: null,
      createdAt: timestamp.fromDate(new Date()),
      userId: user.phoneNumber,
      adminCreatedOrder: true,
      timeline: [
        {
          id: `ORDER_CREATED_${Date.now()}`,
          eventType: isQuickPickup
            ? "QUICK_PICKUP_CREATED"
            : "ADMIN_ORDER_CREATED",
          details: {
            createdByAdmin: true,
            orderTotal: isQuickPickup ? 0 : orderPrice,
            productCount: isQuickPickup ? 0 : orderProducts.length,
            isQuickPickup: isQuickPickup,
            expectedClothsQuantity,
            assignedTo: orderAssignedTo,
          },
          timestamp: timestamp.fromDate(new Date()),
          createdBy: {
            userId: user.phoneNumber,
            userName: user.fullName || user.email || "System",
            role: user.role,
          },
        },
      ],
    };

    try {
      const addedDocRef = await addDocument(orderData);
      const orderId = addedDocRef.id;

      // --- 4. Generate Barcodes ---
      const qrCodeImage = await generateBarcodeDataURL(orderId);
      const productsWithQR = await Promise.all(
        orderProducts.map(async (product, index) => {
          const itemId = `${orderId}-item-${index}`;
          const itemQRCode = await generateItemBarcodeDataURL(orderId, itemId, {
            productId: product.id,
            name: product.name,
            quantity: product.quantity,
          });
          return { ...product, itemId, itemQRCode };
        })
      );

      await addedDocRef.update({
        barcode: { number: orderId, imageUrl: qrCodeImage },
        products: productsWithQR,
      });

      const addedDocSnap = await addedDocRef.get();


            // --- 4.5. Create orderItems documents for each product ---
      if (!isQuickPickup && productsWithQR.length > 0) {
        const orderItemsBatch = projectFirestore.batch();
        
        productsWithQR.forEach((product) => {
          const orderItemRef = projectFirestore
            .collection("orderItems")
            .doc(product.itemId);
          
          const orderItemData = {
            itemId: product.itemId,
            orderId: orderId,
            productId: product.id,
            productName: product.name,
            quantity: product.quantity,
            currentStage: "order-placed",
            currentSubStage: null,
            status: "in_progress",
            issues: [],
            history: [],
            createdAt: timestamp.fromDate(new Date()),
            updatedAt: timestamp.fromDate(new Date()),
          };
          
          orderItemsBatch.set(orderItemRef, orderItemData);
        });
        
        await orderItemsBatch.commit();
        console.log(`Created ${productsWithQR.length} orderItems documents (Admin Order).`);
      }



      // --- 5. Handle Subscription Child Orders (Batch) ---
      if (isSubscription && totalOrders > 1) {
        const batch = projectFirestore.batch();

        for (let i = 1; i < totalOrders; i++) {
          let nextDeliveryDate;

          if (subscriptionDetails.isWeekly) {
            nextDeliveryDate = new Date(subscriptionBaseDate.getTime());
            nextDeliveryDate.setDate(subscriptionBaseDate.getDate() + i * 7);
          } else {
            nextDeliveryDate = getNextMonthDate(subscriptionBaseDate, i);
          }

          const newOrderRef = projectFirestore.collection("orders").doc();

          const repeatOrder = {
            ...orderData,
            estimatedDeliveryDate: nextDeliveryDate,
            subscriptionParentOrder: addedDocSnap.id,
            subscriptionIndex: i,
            createdAt: timestamp.fromDate(new Date()),
            orderStatus:
              orderData.paymentMethod === "online"
                ? "payment_pending"
                : "pending",
            currentOrderStage: "orderPlaced",
            orderStages: {
              orderPlaced: {
                completed: true,
                timestamp: timestamp.fromDate(new Date()),
              },
              itemsPickedUp: { completed: false, timestamp: null },
              processing: { completed: false, timestamp: null },
              delivered: { completed: false, timestamp: null },
            },
            payment: {
              ...orderData.payment,
              status: "pending",
              transactionId: "",
              details: null,
            },
            timeline: [
              {
                id: `SUBSCRIPTION_ORDER_${Date.now()}_${i}`,
                eventType: "SUBSCRIPTION_ORDER_CREATED",
                details: {
                  frequencyType: firstProduct.selectedFrequencyType,
                  deliveryInterval: firstProduct.deliveryInterval,
                  selectedDay: subscriptionDetails.selectedDay || null,
                  selectedDate: subscriptionDetails.selectedDate || null,
                  createdFromParent: addedDocSnap.id,
                  scheduledFor: nextDeliveryDate.toISOString(),
                },
                timestamp: timestamp.fromDate(new Date()),
                createdBy: {
                  userId: user.phoneNumber,
                  userName: user.fullName || user.email || "System",
                  role: user.role,
                },
              },
            ],
          };

          batch.set(newOrderRef, repeatOrder);
        }

        await batch.commit();
        console.log(
          `Admin subscription child orders (${
            totalOrders - 1
          }) created successfully.`
        );
      }

      // START FOR SEND EMAIL (Order Confirmation UI)
      if (dbEmailDoc && dbEmailDoc.status === true) {
        const order = addedDocSnap.data();

        // make sure you have order data available here
        const placedOrderId = orderId || "Order Id";

        const orderDate = order?.createdAt
          ? new Date(order.createdAt.seconds * 1000).toLocaleString()
          : new Date().toLocaleString();

        // orderItems should be an array of { name, qty, price, variant(optional) }
        const orderItems =
          order?.products ||
          [
            // sample item if none provided
            // { name: "Sample Product", variant: "Red / M", qty: 1, price: 499 }
          ];

        const total = order?.totalPrice;
        const paymentMethod = order?.paymentMethod || "Online";
        let deliveryAddress = `${user?.fullName || ""}, ${
          user?.phoneNumber || ""
        }`;
        if (order?.shippingAddress) {
          const a = order.shippingAddress;
          deliveryAddress = `
    ${a.name || ""}<br>
    ${a.houseNumber || ""}, ${a.streetLineOne || ""}<br>
    ${a.streetLineTwo ? a.streetLineTwo + "<br>" : ""}
    ${a.landmark ? a.landmark + "<br>" : ""}
    ${a.city || ""}, ${a.state || ""} - ${a.pincode || ""}<br>
    <span style="font-size:12px; color:#666;">(${a.type || "home"})</span>`;
        }
        let expectedDelivery = "Typically 7–10 business days";

        if (order?.estimatedDeliveryDate) {
          try {
            const d =
              order.estimatedDeliveryDate.toDate?.() ||
              new Date(order.estimatedDeliveryDate.seconds * 1000);

            expectedDelivery = d.toLocaleDateString("en-IN", {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
            });
          } catch (e) {
            console.log("Delivery date parse error:", e);
          }
        }

        // Build items rows HTML safely
        const itemsRows = orderItems.length
          ? orderItems
              .map(
                (it) => `
      <tr style="background:#fff;">
     <td style="padding:10px 12px; border-bottom:1px solid #eee;">
  <div style="display:flex; align-items:center; gap:10px;">  
    ${
      it.images && it.images.length > 0
        ? `<img 
           src="${it.images[0]}" 
           alt="Item"
           width="50" 
           height="50" 
           style="border-radius:6px; object-fit:cover;"
         />`
        : ""
    }
    <div>
      <div style="font-weight:600; color:#333;">${it.name || ""}</div>
      ${
        it.variant
          ? `<div style="font-size:12px; color:#777;">${it.variant}</div>`
          : ""
      }
    </div>
  </div>
</td>
        <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:center; color:#333;">${
          it.quantity
        }</td>
        <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:right; color:#333;">
  <div style="font-size:12px; color:#777;">
₹${it.price} * ${it.quantity}
  </div>
   ₹${(it.price * it.quantity).toFixed(2)}
</td>
      </tr>`
              )
              .join("")
          : `<tr><td colspan="3" style="padding:18px; text-align:center; color:#777;">No items found</td></tr>`;

        let assignedUserEmail = null;
        let assignedUserName = null;
        let assignedUserPhone = null;

        try {
          const assignedUserDoc = await projectFirestore
            .collection("users")
            .doc(orderAssignedTo) // since docId = phone number
            .get();

          if (assignedUserDoc.exists) {
            assignedUserEmail = assignedUserDoc.data().email || null;
            assignedUserName = assignedUserDoc.data().fullName || null;
            assignedUserPhone = assignedUserDoc.data().phoneNumber || null;

            console.log("Assigned User Email:", assignedUserEmail);
          } else {
            console.log("Assigned user not found for:", orderAssignedTo);
          }
        } catch (err) {
          console.error("Error fetching assigned user:", err);
        }

        const toList = [user?.email || "", assignedUserEmail || ""].filter(
          Boolean
        );
        const ccList = dbEmailDoc?.ccList || [];
        const bccList = dbEmailDoc?.bccList || [];
        const emailSubject =
          dbEmailDoc?.subject || `Order Confirmation - ${order}`;

        const htmlEmailBody = `
  <div style="font-family: Arial, sans-serif; background-color:#f4f6f9; padding:20px;">
    <table width="100%" border="0" cellspacing="0" cellpadding="0"
      style="max-width:700px; margin:0 auto; background:#ffffff; border-radius:12px; overflow:hidden; box-shadow:0 6px 18px rgba(0,0,0,0.06);">
      
      <!-- Header -->
      <tr>
        <td style="background: ${
          siteColors?.LightScreenTheme?.clickColor || "#0b4c8c"
        }; padding:26px 20px; text-align:left; color:#fff;">
          <table width="100%"><tr>
            <td style="vertical-align:middle;">
              <img src="${
                organisationDoc?.logoUrl || ""
              }" alt="Logo" width="120" style="vertical-align:middle; border-radius:6px;" />
            </td>
            <td style="text-align:right; vertical-align:middle;">
              <div style="font-size:18px; font-weight:600;">Order Confirmed</div>
              <div style="font-size:13px; opacity:0.9; margin-top:6px;">Order # <strong>${placedOrderId}</strong></div>
              <div style="font-size:12px; opacity:0.85; margin-top:4px;">${orderDate}</div>
            </td>
          </tr></table>
        </td>
      </tr>

      <!-- Greeting / Intro -->
      <tr>
        <td style="padding:22px 28px;">
          <h2 style="margin:0 0 6px 0; font-size:20px; color:#222;">Thanks for your order, ${
            user?.fullName || "Customer"
          } 👋</h2>
          <p style="margin:6px 0 0 0; font-size:14px; color:#555;">
            We’ve received your order and are getting it ready. Below are the details for your reference.
          </p>
        </td>
      </tr>

      <!-- Customer & Order Summary -->
     <tr>
  <td style="padding:0 28px 22px 28px;">
    <table width="100%" cellpadding="10" cellspacing="0" style="border-collapse:collapse; font-size:14px;">
      <tr class="two-col">
        <!-- LEFT (Customer) -->
        <td width="48%" style="vertical-align:top; padding-right:10px;">
          <div style="font-weight:700; color:#333; margin-bottom:8px;">Customer Details</div>
          <div style="color:#444;">${assignedUserName || ""}</div>
          <div style="color:#444;">${assignedUserEmail || ""}</div>
          <div style="color:#444;">${assignedUserPhone || ""}</div>
        </td>

        <!-- RIGHT (Delivery) -->
        <td width="52%" style="vertical-align:top; padding-left:10px;">
          <div style="font-weight:700; color:#333; margin-bottom:8px;">Delivery Details</div>
          <div style="color:#444;">${deliveryAddress}</div>
          <div style="margin-top:8px; color:#666; font-size:13px;">
            Expected delivery: <strong>${expectedDelivery}</strong>
          </div>
          <div style="margin-top:6px; color:#666; font-size:13px;">
            Payment: <strong>${paymentMethod}</strong>
          </div>
        </td>
      </tr>
    </table>
  </td>
</tr>

      <!-- Items Table -->
      <tr>
        <td style="padding:0 28px 8px 28px;">
          <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse; font-size:14px;">
            <thead>
              <tr style="background:#f7fafc;">
                <th style="text-align:left; padding:12px; color:#666; font-weight:600;">Item</th>
                <th style="text-align:center; padding:12px; color:#666; font-weight:600;">Qty</th>
                <th style="text-align:right; padding:12px; color:#666; font-weight:600;">Price</th>
              </tr>
            </thead>
            <tbody>
              ${itemsRows}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- Totals -->
      <tr>
        <td style="padding:10px 28px 22px 28px;">
          <table width="100%" cellpadding="6" cellspacing="0" style="font-size:14px; border-collapse:collapse;">
            <tr style="border-top:1px solid #eee;">
              <td style="font-size:16px; font-weight:700;">Total</td>
              <td style="text-align:right; font-size:16px; font-weight:700;">₹${total.toFixed(
                2
              )}</td>
            </tr>
          </table>
        </td>
      </tr>

      <!-- CTA Buttons -->
      <tr>
        <td style="padding:0 28px 26px 28px; text-align:center;">
         <a href="${
           organisationDoc?.siteUrl
             ? `${organisationDoc.siteUrl}/order-details/${placedOrderId}`
             : "#"
         }" 
  target="_blank"
  style="display:inline-block; background:${
    siteColors?.LightScreenTheme?.clickColor || "#0b4c8c"
  }; color:#fff; padding:12px 20px; border-radius:8px; text-decoration:none; font-weight:600; margin-right:10px;">
  View Order
</a>

            <a href="${
              organisationDoc?.siteUrl
                ? `${organisationDoc.siteUrl}/orders`
                : "#"
            }" 
  target="_blank"
  style="display:inline-block; background:#f1f5f9; color:#333; padding:12px 18px; border-radius:8px; text-decoration:none; font-weight:600; border:1px solid #e2e8f0;">
  Track Order
</a>
        </td>
      </tr>

      <!-- Footer -->
      <tr>
        <td style="background:#fafafa; padding:18px 20px; text-align:center; font-size:12px; color:#888;">
          If you have any questions, reply to this email or contact our support.<br/>
          &copy; ${new Date().getFullYear()} ${
          organisationDoc?.full_name || ""
        }. All rights reserved.
        </td>
      </tr>
    </table>
  </div>
  `;
        // send (keeps your current signature - you can change to sendMyEmail(toList, htmlEmailBody) if hook changed)
        await sendMyEmail(toList, ccList, bccList, emailSubject, htmlEmailBody);
      }
      //  END FOR SEND EMAIL

      return { id: addedDocSnap.id, ...addedDocSnap.data() };
    } catch (error) {
      console.error("Error creating admin order:", error);
      return null;
    }
  };

  // const createAdminOrder = async (
  //   orderProducts,
  //   orderPrice,
  //   address = null,
  //   paymentMethod,
  //   instruction = null,
  //   giftMessages,
  //   orderAssignedTo,
  //   paymentDetails = null,
  //   isQuickPickup = false,
  //   expectedClothsQuantity = null
  // ) => {
  //   const orderData = {
  //     products: isQuickPickup ? [] : orderProducts,
  //     totalPrice: isQuickPickup ? 0 : orderPrice,
  //     shippingAddress: address || null,
  //     paymentMethod: paymentMethod,
  //     instruction: instruction || null,
  //     giftMessages: giftMessages || "",
  //     orderStatus: paymentMethod === "online" ? "payment_pending" : "pending",
  //     currentOrderStage: "orderPlaced",
  //     orderType: isQuickPickup ? "quick_pickup" : "normal",
  //     estimatedDeliveryDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
  //     expectedClothsQuantity: expectedClothsQuantity
  //       ? expectedClothsQuantity
  //       : null,
  //     orderStages: {
  //       orderPlaced: {
  //         completed: true,
  //         timestamp: timestamp.fromDate(new Date()),
  //       },
  //       itemsPickedUp: {
  //         completed: false,
  //         timestamp: null,
  //       },
  //       processing: {
  //         completed: false,
  //         timestamp: null,
  //       },
  //       delivered: {
  //         completed: false,
  //         timestamp: null,
  //       },
  //     },

  //     // Add location fields
  //     selectedLocation: user?.selectedLocation || null,

  //     // Payment related fields
  //     payment: {
  //       method: paymentMethod,
  //       status: paymentDetails?.paymentStatus || "pending",
  //       transactionId: paymentDetails?.transactionID || "",
  //       amount: orderPrice,
  //       currency: "INR",
  //       timestamp:
  //         paymentDetails?.paymentDetails?.timestamp ||
  //         timestamp.fromDate(new Date()),
  //       details: paymentDetails?.paymentDetails || null,
  //       refund: {
  //         status: "none",
  //         amount: 0,
  //         timestamp: null,
  //         transactionId: "",
  //       },
  //     },

  //     // Add staff assignment fields with orderAssignedTo
  //     orderAssignedTo: orderAssignedTo,
  //     orderAssignedOn: timestamp.fromDate(new Date()),
  //     pickupStaff: null,
  //     processingStaff: null,
  //     deliveryStaff: null,

  //     //START PAYMENT RELATED FIELDS
  //     transactionid: "",
  //     transactionstatus: "",
  //     transactiontimestamp: "",
  //     transactionamount: "",
  //     isrefunded: "",
  //     refundedamount: "",
  //     refundedtimestamp: "",
  //     refundstatus: "",
  //     //END PAYMENT RELATED FIELDS

  //     createdAt: timestamp.fromDate(new Date()),
  //     userId: user.phoneNumber,
  //     adminCreatedOrder: true,
  //     timeline: [
  //       {
  //         id: `ORDER_CREATED_${Date.now()}`,
  //         eventType: isQuickPickup
  //           ? "QUICK_PICKUP_CREATED"
  //           : "ADMIN_ORDER_CREATED",
  //         details: {
  //           createdByAdmin: true,
  //           orderTotal: isQuickPickup ? 0 : orderPrice,
  //           productCount: isQuickPickup ? 0 : orderProducts.length,
  //           isQuickPickup: isQuickPickup,
  //           expectedClothsQuantity: expectedClothsQuantity,
  //           assignedTo: orderAssignedTo,
  //         },
  //         timestamp: timestamp.fromDate(new Date()),
  //         createdBy: {
  //           userId: user.phoneNumber,
  //           userName: user.fullName || user.email || "System",
  //           role: user.role,
  //         },
  //       },
  //     ],
  //   };

  //   console.log("Admin order created");

  //   try {
  //     const addedDocRef = await addDocument(orderData);
  //     const orderId = addedDocRef.id;

  //     // Generate QR code
  //     const qrCodeImage = await generateBarcodeDataURL(orderId);

  //     // Generate QR codes for each item in the order
  //     const productsWithQR = await Promise.all(
  //       orderProducts.map(async (product, index) => {
  //         const itemId = `${orderId}-item-${index}`;
  //         const itemQRCode = await generateItemBarcodeDataURL(orderId, itemId, {
  //           productId: product.id,
  //           name: product.name,
  //           quantity: product.quantity,
  //         });

  //         return {
  //           ...product,
  //           itemId,
  //           itemQRCode,
  //         };
  //       })
  //     );

  //     // Update the document with the QR codes
  //     const updates = {
  //       barcode: {
  //         number: orderId,
  //         imageUrl: qrCodeImage,
  //       },
  //       products: productsWithQR,
  //     };

  //     if (paymentDetails) {
  //       const paymentEvent = {
  //         id: `PAYMENT_${Date.now()}`,
  //         eventType: "PAYMENT",
  //         details: {
  //           status: paymentDetails.paymentStatus,
  //           transactionId: paymentDetails.transactionID,
  //           amount: orderPrice,
  //           method: paymentMethod,
  //         },
  //         timestamp: timestamp.fromDate(new Date()),
  //         createdBy: {
  //           userId: user.phoneNumber,
  //           userName: user.fullName || user.email || "System",
  //           role: user.role,
  //         },
  //       };
  //       updates.timeline = [...(orderData.timeline || []), paymentEvent];
  //     }

  //     await addedDocRef.update(updates);

  //     const addedDocSnap = await addedDocRef.get();

  //     // ✅ Handle "Subscribe & Save" — auto-create future admin orders
  //     // ✅ Handle "Subscribe & Save" — auto-create future orders
  //     const firstProduct = orderProducts[0];
  //     if (
  //       firstProduct?.selectedFrequencyType &&
  //       firstProduct?.deliveryInterval
  //     ) {
  //       const isWeekly = firstProduct.selectedFrequencyType === "weekly";
  //       const totalOrders = parseInt(firstProduct.deliveryInterval);
  //       const selectedDay = firstProduct.selectedDay; // e.g., "Monday"
  //       const selectedDate = firstProduct.selectedDate; // e.g., "2025-11-05"

  //       // Helper to find next weekday date
  //       const getNextWeekdayDate = (dayName, weekOffset = 0) => {
  //         const daysOfWeek = [
  //           "Sunday",
  //           "Monday",
  //           "Tuesday",
  //           "Wednesday",
  //           "Thursday",
  //           "Friday",
  //           "Saturday",
  //         ];
  //         const targetDay = daysOfWeek.indexOf(dayName);
  //         const now = new Date();
  //         const date = new Date(now);
  //         const diff = (targetDay - now.getDay() + 7) % 7;
  //         date.setDate(now.getDate() + diff + weekOffset * 7);
  //         return date;
  //       };

  //       // Helper to find next month date
  //       const getNextMonthDate = (baseDateStr, monthOffset = 0) => {
  //         const base = new Date(baseDateStr);
  //         const next = new Date(base);
  //         next.setMonth(base.getMonth() + monthOffset);
  //         return next;
  //       };

  //       for (let i = 0; i < totalOrders; i++) {
  //         let nextDeliveryDate;

  //         if (isWeekly && selectedDay) {
  //           nextDeliveryDate = getNextWeekdayDate(selectedDay, i);
  //         } else if (!isWeekly && selectedDate) {
  //           nextDeliveryDate = getNextMonthDate(selectedDate, i);
  //         } else {
  //           // Fallback (7 days apart for weekly, 30 days apart for monthly)
  //           nextDeliveryDate = new Date();
  //           nextDeliveryDate.setDate(
  //             nextDeliveryDate.getDate() + i * (isWeekly ? 7 : 30)
  //           );
  //         }

  //         const repeatOrder = {
  //           ...orderData,
  //           estimatedDeliveryDate: nextDeliveryDate,
  //           subscriptionParentOrder: addedDocSnap.id,
  //           subscriptionIndex: i + 1,
  //           createdAt: timestamp.fromDate(new Date()),
  //           timeline: [
  //             {
  //               id: `SUBSCRIPTION_ORDER_${Date.now()}_${i}`,
  //               eventType: "SUBSCRIPTION_ORDER_CREATED",
  //               details: {
  //                 frequencyType: firstProduct.selectedFrequencyType,
  //                 deliveryInterval: firstProduct.deliveryInterval,
  //                 selectedDay: selectedDay || null,
  //                 selectedDate: selectedDate || null,
  //                 createdFromParent: addedDocSnap.id,
  //               },
  //               timestamp: timestamp.fromDate(new Date()),
  //               createdBy: {
  //                 userId: user.phoneNumber,
  //                 userName: user.fullName || user.email || "System",
  //                 role: user.role,
  //               },
  //             },
  //           ],
  //         };

  //         await addDocument(repeatOrder);
  //       }
  //     }

  //     return { id: addedDocSnap.id, ...addedDocSnap.data() };
  //   } catch (error) {
  //     console.error("Error creating admin order:", error);
  //     return null;
  //   }
  // };

  const getOrderInfo = async (id) => {
    const order = orders.find((order) => order.id === id);
    return order;
  };

  const updateOrder = async (id, status) => {
    try {
      await updateDocument(id, { orderStatus: status });
    } catch (err) {
      console.log("Error updating order", err);
    }
  };

  const addTimelineEvent = async (orderId, eventType, details) => {
    try {
      // Get current order
      const orderRef = projectFirestore.collection("orders").doc(orderId);
      const orderDoc = await orderRef.get();
      const currentOrder = orderDoc.data();

      // Create new event
      const newEvent = {
        id: Date.now().toString(), // Simple unique ID
        eventType,
        details,
        timestamp: timestamp.fromDate(new Date()),
        createdBy: {
          userId: user.phoneNumber,
          userName: user.fullName || user.email || "System",
          role: user.role,
        },
      };

      // Add event to timeline array (create if doesn't exist)
      const timeline = currentOrder.timeline || [];
      timeline.unshift(newEvent); // Add to beginning of array

      // Update order document
      await updateDocument(orderId, { timeline });

      return newEvent;
    } catch (error) {
      console.error("Error adding timeline event:", error);
      throw error;
    }
  };

  const assignOrder = async (orderId, assignedToUserId) => {
    try {
      await updateDocument(orderId, {
        orderAssignedTo: assignedToUserId,
        orderAssignedOn: timestamp.fromDate(new Date()),
      });

      // Add timeline event
      await addTimelineEvent(orderId, "ORDER_ASSIGNED", {
        assignedToUserId,
      });
    } catch (err) {
      console.log("Error assigning order", err);
      throw err;
    }
  };

  // Add new method for updating payment status
  const updatePaymentStatus = async (orderId, paymentDetails) => {
    try {
      const updates = {
        "payment.status": paymentDetails.paymentStatus,
        "payment.transactionId": paymentDetails.transactionID,
        "payment.details": paymentDetails.paymentDetails,
        orderStatus:
          paymentDetails.paymentStatus === "Success"
            ? "pending"
            : "payment_failed",
      };

      await updateDocument(orderId, updates);

      // Add payment event to timeline
      await addTimelineEvent(orderId, "PAYMENT_UPDATE", {
        status: paymentDetails.paymentStatus,
        transactionId: paymentDetails.transactionID,
        details: paymentDetails.paymentDetails,
      });

      return true;
    } catch (error) {
      console.error("Error updating payment status:", error);
      return false;
    }
  };

  // Add a new convenience method for creating quick pickups
  const createQuickPickup = async (address, expectedClothsQuantity) => {
    return createOrder(
      [], // empty products array
      0, // zero total price
      address,
      "cod", // default to COD for quick pickups
      null, // no payment details
      true, // isQuickPickup flag
      expectedClothsQuantity
    );
  };

  const updateOrderProducts = async (orderId, products) => {
    try {
      const updates = {
        products,
        totalPrice: products.reduce(
          (total, product) => total + product.price * product.quantity,
          0
        ),
      };

      await updateDocument(orderId, updates);

      // Add timeline event
      await addTimelineEvent(orderId, "PRODUCTS_ADDED", {
        productCount: products.length,
        totalPrice: updates.totalPrice,
      });

      return true;
    } catch (error) {
      console.error("Error updating order products:", error);
      throw error;
    }
  };

  // Simplify the reorderFromExisting function
  const reorderFromExisting = async (
    modifiedProducts,
    address,
    paymentMethod
  ) => {
    try {
      // Calculate total price from modified products
      const orderPrice = modifiedProducts.reduce(
        (total, product) => total + product.price * product.quantity,
        0
      );

      // Use existing createOrder function with modified data
      const newOrder = await createOrder(
        modifiedProducts,
        orderPrice,
        address,
        paymentMethod
      );

      // if (newOrder) {
      //     // Add a timeline event to link this order to the original order
      //     await addTimelineEvent(newOrder.id, 'REORDER_CREATED', {
      //         originalOrderId: orderId,
      //         productCount: modifiedProducts.length,
      //         orderTotal: orderPrice
      //     });
      // }

      return newOrder;
    } catch (error) {
      console.error("Error creating reorder:", error);
      throw error;
    }
  };

  return {
    orders,
    createOrder,
    createAdminOrder,
    getOrderInfo,
    updateOrder,
    assignOrder,
    addTimelineEvent,
    updatePaymentStatus,
    createQuickPickup,
    updateOrderProducts,
    reorderFromExisting,
  };
};

export default useOrders;
